import React from 'react';

export type InventoryTab = 'stock-today' | 'sales-history' | 'forecast' | 'coverage' | 'projected-stock' | 'security-rop' | 'outstock-declarations';

const TAB_LABELS: Record<InventoryTab, string> = {
  'stock-today': 'Stock aujourd\'hui',
  'sales-history': 'Ventes passées',
  'forecast': 'Prévisions',
  'coverage': 'Couverture projetée',
  'projected-stock': 'Stock projeté',
  'security-rop': 'Sécurité / ROP',
  'outstock-declarations': 'Ruptures déclarées',
};

export const InventoryTabs: React.FC<{
  activeTab: InventoryTab;
  onTabChange: (t: InventoryTab) => void;
  loading?: boolean;
}> = ({ activeTab, onTabChange, loading }) => {
  return (
    <div className="flex-shrink-0 bg-white border-b border-gray-200 relative z-30">
      <div className="flex overflow-x-auto">
        {(Object.keys(TAB_LABELS) as InventoryTab[]).map((tab) => (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={`px-4 py-3 text-sm whitespace-nowrap ${
              activeTab === tab ? 'text-blue-600 border-b-2 border-blue-600 font-medium' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {TAB_LABELS[tab]}{loading && activeTab === tab ? '…' : ''}
          </button>
        ))}
      </div>
    </div>
  );
};

export default InventoryTabs;


